import { REQUEST_BRANDS_LIST_SUCCESS, REQUEST_BRANDS_LIST_FAILURE } from '../constants/actionTypes';

const INITIAL_STATE = { data: {}, errors: null, isLoading: true };

export default function brandsList(state = INITIAL_STATE, action) {
  console.log("brandsList func", action)
  switch (action.type) {
    case REQUEST_BRANDS_LIST_SUCCESS:

      return { ...state, data: action.payload.data, isLoading: false, errors: null }

    case REQUEST_BRANDS_LIST_FAILURE:

      return { ...state, data: {}, isLoading: false, errors: "list not returned" }
    default:
      return state;
  }
}